import React, { useState, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { Button } from '@picsio/ui';
import DropdownTree from '../DropdownTree';
import Icon from '../Icon';
import * as collectionsActions from '../../store/actions/collections';
import { sendFacesForCollectionRecognize } from '../../store/faces/actions';
import localization from '../../shared/strings';
import Logger from '../../services/Logger';

const SendCollectionRecognizeDialog = (props) => {
  const dispatch = useDispatch();

  const {
    title,
    style,
    onClose,
    onOk,
    destroy,
    textBtnOk,
    closeOnToggle,
  } = props;

  const { collections } = useSelector((state) => state.collections);
  const [selectCollectionId, setselectCollectionId] = useState([]);

  const handleClose = useCallback(() => {
    onClose();
    destroy();
  }, [onClose, destroy]);
  const handleOk = useCallback(() => {
    Logger.log('Face', 'FaceRecogPersonDeleted');
    dispatch(sendFacesForCollectionRecognize(selectCollectionId));
    onOk();
    destroy();
  }, [destroy, onOk, selectCollectionId]);

  useEffect(() => {
    /** @param {KeyboardEvent} event */
    // eslint-disable-next-line consistent-return
    const keyListener = (event) => {
      // eslint-disable-next-line default-case
      switch (event.key) {
      case 'Enter':
        return handleClose();
      case 'Escape':
        return handleClose();
      }
    };

    window.addEventListener('keydown', keyListener);
    return () => {
      window.removeEventListener('keydown', keyListener);
    };
  });

  const handleToggleCollection = (collection) => {
    const clonnedCollection = { ...collection };
    clonnedCollection.path = (clonnedCollection.path + clonnedCollection.name).substring(1);
    if (!selectCollectionId.includes(clonnedCollection._id)) {
      Logger.log('User', 'AttachCollectionDialogAddCollection', { collectionId: collection._id });
      setselectCollectionId(collection._id);
    }

    if (closeOnToggle) {
      handleClose();
    }
  };

  const handleCreateCollection = useCallback(
    (parent, name) => dispatch(collectionsActions.addCollection(
      `${parent.path}${parent.name}/`,
      name,
      parent._id,
    )),
    [dispatch],
  );

  return (
    <div className="simpleDialog moveCollectionDialog">
      <div className="simpleDialogUnderlayer" />
      <div className="simpleDialogBox" style={style}>
        <div className="simpleDialogHeader">
          <span className="simpleDialogTitle">
            {title}
          </span>
          <span
            className="simpleDialogBtnCross"
            role="button"
            tabIndex={0}
            onKeyPress={handleClose}
            onClick={handleClose}
          >
            <Icon name="close" />
          </span>
        </div>
        <div className="simpleDialogContent">
          <div className="simpleDialogContentInner">
            <DropdownTree
              checkedItems={selectCollectionId}
              treeListItems={[collections.my]}
              onClick={handleToggleCollection}
              loadChildren={(item) => dispatch(collectionsActions.getChildren(item._id))}
              createCollection={handleCreateCollection}
              iconSpecial="folder"
              disableRoot
              type="attach"
            />
          </div>
        </div>
        <div className="simpleDialogFooter">
          {textBtnOk !== null && (
            <Button
              color="primary"
              size="md"
              variant="contained"
              tabIndex={0}
              onClick={handleOk}
              disabled={selectCollectionId.length === 0}
            >
              {textBtnOk}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

/** Prop types */
SendCollectionRecognizeDialog.propTypes = {
  treeListItems: PropTypes.array,
  onLoadChildren: PropTypes.func,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  style: PropTypes.object,
  textBtnOk: PropTypes.string,
  textBtnCancel: PropTypes.string,
  onClose: PropTypes.func,
  onOk: PropTypes.func,
  destroy: PropTypes.func,
  collectionToMove: PropTypes.object,
  closeOnToggle: PropTypes.bool,
};

/** Default props */
SendCollectionRecognizeDialog.defaultProps = {
  title: '',
  style: {},
  onOk: () => { },
  onClose: () => { },
  destroy: () => { },
  textBtnOk: null,
  textBtnCancel: localization.DIALOGS.btnOk,
  collectionToMove: {},
  closeOnToggle: false,
};

export default SendCollectionRecognizeDialog;
